import React from 'react'
import { Title } from '@devexpress/dx-react-chart-material-ui'
import { useStyles } from './styles'
import Help from '@material-ui/icons/Help'

const titleStyle = { margin: 'auto' }
const TitleText = props => {
  const classes = useStyles()
  return (
    <div className={classes.titleContainer}>
      <div className={classes.text}>
        <Title.Text {...props} style={titleStyle} />
      </div>
      <div className={classes.icon}>
        <Help
          viewBox='0 0 26 26'
          titleAccess='This chart shows how quickly your users are making progress, in terms of the number of days they’re taking to complete a single Step. A value like 2 is very fast, 4 is pretty typical. Users are divided into quartiles based on how active they area. Q1 contains the most active users, Q2 the second most, and so on.'
        />
      </div>
    </div>
  )
}

export default TitleText
